import React, {Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import WOW from 'wowjs';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
// Images
import ban1 from './../../../images/banner/ban1.jpeg';
import ban2 from './../../../images/banner/ban2.jpeg';
import banner from './../../../images/banner/banner.jpeg';
import bannerImg1 from './../../../images/banner/towera.png';
import bannerImg2 from './../../../images/banner/img.png';
import bannerImg3 from './../../../images/banner/towerb.png';
import bannerImg4 from './../../../images/banner/img4.jpg';

class GoldcrestDreamTowerB extends Component{
	componentDidMount(){
		new WOW.WOW().init();
	}
	
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Projects" activeMenu="Goldcrest Dream Tower B" />
					
					{/* Project Overview Section */}
					<section className="content-inner project-overview-section">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-4 mb-lg-0">
									<div className="row">
										<div className="col-6 mb-3">
											<img src={ban1} alt="Goldcrest Tower B" className="project-gallery-image" />
										</div>
										<div className="col-6 mb-3">
											<img src={bannerImg1} alt="Project Image 1" className="project-gallery-image" />
										</div>
										<div className="col-6 mb-3">
											<img src={bannerImg2} alt="Project Image 2" className="project-gallery-image" />
										</div>
										<div className="col-6 mb-3">
											<img src={bannerImg3} alt="Project Image 3" className="project-gallery-image" />
										</div>
									</div>
								</div>
								<div className="col-lg-6">
									<h2 className="project-title">Goldcrest Dream Tower B</h2>
									<p className="project-price">Starting from AED425,485</p>
									<p className="project-description">
										Goldcrest Dream Tower B is a prestigious residential complex located in Emirates City, Ajman. This modern development features 75 residential apartments including studio, 1-bedroom, and 2-bedroom units. The tower offers world-class amenities including a rooftop swimming pool, fully equipped gym, and sauna facilities, providing residents with a luxurious lifestyle experience.
									</p>
									<Link 
										to="/contact-us" 
										className="btn btn-primary project-consultation-btn"
									>
										REQUEST A CONSULTATION
									</Link>
								</div>
							</div>
						</div>
					</section>

					{/* About This Home Section */}
					<section className="content-inner project-about-section">
						<div className="container">
							<div className="row text-center text-white justify-content-center">
								<div className="col-md-2 col-6 mb-4 mb-md-0">
									<div className="project-feature-card">
										<i className="ti-home project-feature-icon"></i>
										<h4 className="project-feature-title">1,2 Bedrooms</h4>
									</div>
								</div>
								<div className="col-md-2 col-6 mb-4 mb-md-0">
									<div className="project-feature-card">
										<i className="ti-layout project-feature-icon"></i>
										<h4 className="project-feature-title">1,2 Bathrooms</h4>
									</div>
								</div>
								<div className="col-md-2 col-6 mb-4 mb-md-0">
									<div className="project-feature-card">
										<i className="ti-ruler-alt-2 project-feature-icon"></i>
										<h4 className="project-feature-title">856.93 Sq Ft</h4>
									</div>
								</div>
								<div className="col-md-2 col-6 mb-4 mb-md-0">
									<div className="project-feature-card">
										<i className="ti-calendar project-feature-icon"></i>
										<h4 className="project-feature-title">64' Year</h4>
									</div>
								</div>
								<div className="col-md-2 col-6 mb-4 mb-md-0">
									<div className="project-feature-card">
										<i className="ti-layers project-feature-icon"></i>
										<h4 className="project-feature-title">72' Units</h4>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* Project Details Section */}
					<section className="content-inner project-details-section">
						<div className="container">
							<div className="row">
								<div className="col-lg-12">
									<div className="project-details-card">
										<h3 className="project-details-heading">Project Details</h3>
										<div className="row">
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Property ID</strong>
													<span className="project-detail-value project-detail-value-highlight">2600</span>
												</div>
											</div>
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Price</strong>
													<span className="project-detail-value project-detail-value-highlight">AED425,485</span>
												</div>
											</div>
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Property Date</strong>
													<span className="project-detail-value">2023</span>
												</div>
											</div>
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Property Type</strong>
													<span className="project-detail-value">Residential</span>
												</div>
											</div>
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Bedrooms</strong>
													<span className="project-detail-value">1, 2</span>
												</div>
											</div>
											<div className="col-6 mb-4">
												<div className="project-detail-item">
													<strong className="project-detail-label">Bathrooms</strong>
													<span className="project-detail-value">1, 2</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* In a Nutshell Section */}
					<section className="content-inner project-nutshell-section">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-4 mb-lg-0">
									<div className="project-nutshell-header">
										<div className="project-nutshell-icon-wrapper">
											<i className="ti-trophy project-nutshell-icon"></i>
										</div>
										<h3 className="project-nutshell-title">In a Nutshell</h3>
									</div>
									<ul className="project-nutshell-list">
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Four residential towers in Emirates City</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Comprised of 75 residential apartments</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Rooftop swimming pool, gym, sauna</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Spacious ground floor retail area</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Easy access to major highways</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Landscaped gardens</span>
										</li>
										<li className="project-nutshell-item">
											<i className="fa fa-check-circle project-nutshell-check-icon"></i>
											<span className="project-nutshell-text">Close to Sheikh Mohammed Bin Zayed Road</span>
										</li>
									</ul>
								</div>
								<div className="col-lg-6">
									<div className="row">
										<div className="col-6 mb-3">
											<img src={bannerImg2} alt="Project Image" className="project-nutshell-image" />
										</div>
										<div className="col-6 mb-3">
											<img src={bannerImg4} alt="Project Image" className="project-nutshell-image" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* Building Details Section */}
					<section className="content-inner project-building-details-section">
						<div className="container">
							<div className="section-head text-center mb-5">
								<h3 className="project-section-title">BUILDING DETAILS</h3>
								<div className="project-section-divider"></div>
							</div>
							<div className="row">
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-car project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Parking</h4>
										<p className="project-building-text">
											Ample parking spaces are available for residents and visitors, ensuring convenient access to the building at all times.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-arrow-up project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Elevators</h4>
										<p className="project-building-text">
											High-speed elevators provide quick and efficient access to all floors, ensuring residents can reach their apartments with ease.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-shield project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Security, Central Air-Conditioning and Maintenance Services</h4>
										<p className="project-building-text">
											24/7 security services, central air-conditioning system, and professional maintenance services ensure a comfortable and secure living environment.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-pulse project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Gym and Fitness Facilities</h4>
										<p className="project-building-text">
											Fully equipped gym and fitness center with modern equipment, allowing residents to maintain their fitness routine without leaving the building.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-heart project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Lifestyle Amenities</h4>
										<p className="project-building-text">
											Rooftop swimming pool, sauna, and steam room provide residents with premium lifestyle amenities for relaxation and wellness.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-headphone project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Concierge and Guest Services</h4>
										<p className="project-building-text">
											24-hour concierge and guest services ensure residents receive exceptional service and support whenever needed.
										</p>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-building-card">
										<div className="project-building-icon-wrapper">
											<i className="ti-bolt project-building-icon"></i>
										</div>
										<h4 className="project-building-title">Safety Features</h4>
										<p className="project-building-text">
											Comprehensive fire safety systems and emergency exits are installed throughout the building to ensure the safety and security of all residents.
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* Apartment Details Section */}
					<section className="content-inner project-apartment-details-section">
						<div className="container">
							<div className="section-head text-center mb-5">
								<h3 className="project-section-title">APARTMENT DETAILS</h3>
								<div className="project-section-divider"></div>
							</div>
							<div className="mb-5 text-center">
								<p className="project-apartment-intro">
									Goldcrest Dream Tower B offers a variety of apartment types designed to meet different lifestyle needs, from compact studios to spacious 2-bedroom units.
								</p>
							</div>
							<div className="row">
								<div className="col-lg-6 mb-4">
									<div className="project-apartment-card">
										<h4 className="project-apartment-card-title">1-Bedroom Apartments in Goldcrest Towers, Ajman</h4>
										<p className="project-apartment-card-description">
											Our 1-bedroom apartments range from 600-800 sq ft and feature:
										</p>
										<ul className="project-apartment-features-list">
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Spacious living and dining area</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Modern kitchen with quality finishes</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Comfortable bedroom</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Well-appointed bathroom</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Private balcony</span>
											</li>
										</ul>
									</div>
								</div>
								<div className="col-lg-6 mb-4">
									<div className="project-apartment-card">
										<h4 className="project-apartment-card-title">2-Bedroom Apartments in Goldcrest Towers, Ajman</h4>
										<p className="project-apartment-card-description">
											Our 2-bedroom apartments range from 1000-1200 sq ft and include all features of 1-bedroom units plus:
										</p>
										<ul className="project-apartment-features-list">
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Additional bedroom</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">Additional bathroom</span>
											</li>
											<li className="project-apartment-feature-item">
												<i className="fa fa-check-circle project-apartment-feature-icon"></i>
												<span className="project-apartment-feature-text">More spacious living areas</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* CTA Section */}
					{/* <section className="content-inner project-cta-section">
						<div className="container">
							<div className="row">
								<div className="col-12 text-center">
									<h2 className="project-cta-title">
										Would you like to speak to an expert?
									</h2>
									<Link 
										to="/contact-us"
										className="btn btn-primary project-cta-button"
									>
										REQUEST A CONSULTATION
									</Link>
								</div>
							</div>
						</div>
					</section> */}
				</div>
				<FooterPremium />
				<style>{`
					.project-overview-section {
						padding: 80px 0;
						background-color: #fff;
					}
					.project-gallery-image {
						width: 100%;
						height: 200px;
						object-fit: cover;
						border-radius: 10px;
						box-shadow: 0 5px 20px rgba(0,0,0,0.1);
					}
					.project-title {
						font-size: 42px;
						font-weight: 700;
						color: #333;
						margin-bottom: 15px;
						line-height: 1.2;
					}
					.project-price {
						font-size: 28px;
						color: #b8975f;
						font-weight: 700;
						margin-bottom: 25px;
					}
					.project-description {
						font-size: 17px;
						line-height: 1.9;
						color: #666;
						margin-bottom: 35px;
					}
					.project-consultation-btn {
						background-color: #b8975f;
						border: none;
						padding: 16px 45px;
						border-radius: 5px;
						color: #fff;
						font-weight: 700;
						font-size: 16px;
						text-decoration: none;
						display: inline-block;
						transition: all 0.3s ease;
						box-shadow: 0 5px 15px rgba(227, 144, 1, 0.3);
					}
					.project-consultation-btn:hover {
						background-color: #b8975f;
						transform: translateY(-2px);
						box-shadow: 0 8px 20px rgba(227, 144, 1, 0.4);
					}
					.project-about-section {
						padding: 70px 0;
						background-color: black;
						background-image: linear-gradient(135deg, #1a1a1a 0%, #000 100%);
					}
					.project-feature-card {
						padding: 24px 20px;
						background: rgba(255, 255, 255, 0.2);
						backdrop-filter: blur(12px);
						-webkit-backdrop-filter: blur(12px);
						border: 1px solid rgba(255, 255, 255, 0.35);
						border-radius: 16px;
						height: 100%;
						box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
						transition: transform 0.2s ease, box-shadow 0.2s ease;
					}
					.project-feature-card:hover {
						background: rgba(255, 255, 255, 0.28);
						box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
						transform: translateY(-2px);
					}
					.project-feature-icon {
						color: #fff;
						font-size: 40px;
						margin-bottom: 15px;
						display: block;
					}
					.project-feature-title {
						font-size: 20px;
						font-weight: 700;
						margin-bottom: 5px;
						color: #fff;
					}
					.project-details-section {
						padding: 80px 0;
						background-color: #f8f9fa;
					}
					.project-details-card {
						background-color: #fff;
						padding: 40px;
						border-radius: 15px;
						box-shadow: 0 5px 25px rgba(0,0,0,0.08);
						height: 100%;
					}
					.project-details-heading {
						font-size: 32px;
						font-weight: 700;
						color: #333;
						margin-bottom: 35px;
						padding-bottom: 20px;
						border-bottom: 3px solid #b8975f;
					}
					.project-detail-item {
					    border: 1px solid #00000030;
						padding: 15px;
						background-color: #f8f9fa;
						border-radius: 8px;
					}
					.project-detail-label {
						color: #333;
						font-size: 14px;
						display: block;
						margin-bottom: 5px;
					}
					.project-detail-value {
						color: #666;
						font-size: 16px;
						font-weight: 600;
					}
					.project-detail-value-highlight {
						color: #b8975f;
						font-size: 18px;
					}
					.project-progress-item {
						margin-bottom: 25px;
					}
					.project-progress-header {
						display: flex;
						justify-content: space-between;
						margin-bottom: 8px;
					}
					.project-progress-label {
						font-weight: 600;
						font-size: 16px;
						color: #333;
					}
					.project-progress-percent {
						font-weight: 700;
						font-size: 16px;
						color: #b8975f;
					}
					.project-progress-bar {
						width: 100%;
						height: 10px;
						background-color: #e0e0e0;
						border-radius: 15px;
						overflow: hidden;
						box-shadow: inset 0 2px 5px rgba(0,0,0,0.1);
					}
					.project-progress-fill {
						height: 50%;
						background-color: #b8975f;
						transition: all 0.3s ease;
						border-radius: 15px;
					}
					.project-nutshell-section {
						padding: 80px 0;
						background-color: #fff;
					}
					.project-nutshell-header {
						display: flex;
						align-items: center;
						margin-bottom: 35px;
					}
					.project-nutshell-icon-wrapper {
						width: 20px;
						height: 20px;
						background-color: #b8975f;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 20px;
					}
					.project-nutshell-icon {
						font-size: 32px;
						color: #fff;
					}
					.project-nutshell-title {
						font-size: 36px;
						font-weight: 700;
						color: #333;
						margin: 0;
					}
					.project-nutshell-list {
						list-style: none;
						padding: 0;
					}
					.project-nutshell-item {
						margin-bottom: 18px;
						font-size: 17px;
						display: flex;
						align-items: flex-start;
						padding: 12px;
						background-color: #f8f9fa;
						border-radius: 8px;
					}
					.project-nutshell-check-icon {
						color: #b8975f;
						margin-right: 12px;
						margin-top: 3px;
						font-size: 20px;
					}
					.project-nutshell-text {
						color: #333;
						font-weight: 500;
					}
					.project-nutshell-image {
						width: 100%;
						height: 280px;
						object-fit: cover;
						border-radius: 12px;
						box-shadow: 0 8px 25px rgba(0,0,0,0.15);
					}
					.project-building-details-section {
						padding: 80px 0;
						background-color: #f8f9fa;
					}
					.project-section-title {
						font-size: 42px;
						font-weight: 700;
						color: #333;
						margin-bottom: 15px;
					}
					.project-section-divider {
						width: 80px;
						height: 4px;
						background-color: #b8975f;
						margin: 0 auto;
						border-radius: 2px;
					}
					.project-building-card {
						background-color: #fff;
						padding: 30px;
						border-radius: 12px;
						box-shadow: 0 5px 20px rgba(0,0,0,0.08);
						height: 100%;
						transition: all 0.3s ease;
					}
					.project-building-card:hover {
						transform: translateY(-5px);
					}
					.project-building-icon-wrapper {
						width: 50px;
						height: 50px;
						background-color: #b8975f;
						border-radius: 10px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-bottom: 20px;
					}
					.project-building-icon {
						font-size: 24px;
						color: #fff;
					}
					.project-building-title {
						font-size: 22px;
						font-weight: 700;
						color: #333;
						margin-bottom: 15px;
					}
					.project-building-text {
						font-size: 16px;
						line-height: 1.8;
						color: #666;
						margin: 0;
					}
					.project-apartment-details-section {
						padding: 80px 0;
						background-color: #fff;
					}
					.project-apartment-intro {
						font-size: 18px;
						line-height: 1.8;
						color: #666;
						max-width: 800px;
						margin: 0 auto;
					}
					.project-apartment-card {
						background-color: #f8f9fa;
						padding: 40px;
						border-radius: 15px;
						box-shadow: 0 5px 20px rgba(0,0,0,0.08);
						height: 100%;
					}
					.project-apartment-card-title {
						font-size: 26px;
						font-weight: 700;
						color: #333;
						margin-bottom: 20px;
						padding-bottom: 15px;
						border-bottom: 2px solid #b8975f;
					}
					.project-apartment-card-description {
						font-size: 17px;
						line-height: 1.8;
						color: #666;
						margin-bottom: 25px;
					}
					.project-apartment-features-list {
						list-style: none;
						padding: 0;
					}
					.project-apartment-feature-item {
						margin-bottom: 12px;
						font-size: 17px;
						display: flex;
						align-items: flex-start;
						padding: 10px;
						background-color: #fff;
						border-radius: 8px;
					}
					.project-apartment-feature-icon {
						color: #b8975f;
						margin-right: 12px;
						margin-top: 3px;
						font-size: 18px;
					}
					.project-apartment-feature-text {
						color: #333;
						font-weight: 500;
					}
					.project-cta-section {
						padding: 80px 0;
						background-image: linear-gradient(135deg, rgba(227, 144, 1, 0.95) 0%, rgba(184, 148, 31, 0.95) 100%);
						background-size: cover;
						position: relative;
					}
					.project-cta-title {
						font-size: 36px;
						font-weight: 700;
						color: #fff;
						margin-bottom: 30px;
					}
					.project-cta-button {
						background-color: #fff;
						border: none;
						padding: 15px 40px;
						border-radius: 5px;
						color: #b8975f;
						font-weight: 700;
						font-size: 18px;
						text-decoration: none;
						display: inline-block;
						transition: all 0.3s ease;
						box-shadow: 0 5px 20px rgba(0,0,0,0.2);
					}
					.project-cta-button:hover {
						background-color: #f8f9fa;
						transform: translateY(-2px);
						box-shadow: 0 8px 25px rgba(0,0,0,0.3);
					}
				`}</style>
			</Fragment>
		)
	}
}

export default GoldcrestDreamTowerB;
